export const DESKTOP_BREAKPOINT = 1280;
export const TABLET_BREAKPOINT = 960;
export const TABLET_PORTRAIT_BREAKPOINT = 670;
export const YANDEX_API_URL = 'https://api-maps.yandex.ru/2.1/?apikey=6eef425c-e691-423c-aeae-58e703385bdb&lang=ru_RU';
